var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Search_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 33,
    height: 35
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.118 13.177c0 7.277-5.9 13.176-13.177 13.176a13.12 13.12 0 0 1-6.054-1.47l-9.473 9.472a2 2 0 0 1-2.828-2.828l9.036-9.036a13.135 13.135 0 0 1-3.857-9.314C7.765 5.899 13.664 0 20.94 0s13.177 5.9 13.177 13.177Zm-4 0a9.176 9.176 0 1 1-18.353 0 9.177 9.177 0 0 1 18.353 0Z",
    fill: "currentcolor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-32-32H68V68H-32V-32Z",
    fill: "currentcolor"
  }))));
};

export default SvgSearch;